/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Gatti Filtrazioni
 * OpenAPI spec version: v1
 */

export type ProprietaMisurataTypeGruppo =
  (typeof ProprietaMisurataTypeGruppo)[keyof typeof ProprietaMisurataTypeGruppo];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProprietaMisurataTypeGruppo = {
  ParticelleIso: "ParticelleIso",
  Rms: "Rms",
  Fft: "Fft",
  NexusPin: "NexusPin",
} as const;
